import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { projectEntrySelectors } from '../../../../store';
import { daysIndex, SupportedSystems } from '../../../../shared';
import { WeekDatesHeaderWrapper, WeekDatesHeaderRow, WeekDatesRow } from './styled';
import { Grid } from '@mantine/core';

const SelectedDaysHeader = ({ 
  selectedDays, 
  currentSystem, 
  monthCompletedHours, 
  monthWorkingHours,
  completedWeeks
}) => {
  const [weeklyHours, setWeeklyHours] = useState(0);
  const applyDeletableRowStyles = currentSystem === SupportedSystems.VPIN;
  const prevSunday = selectedDays[0];
  const startMonth = moment(prevSunday).format('MMM');
  useEffect(() => {
    prevSunday.setDate(prevSunday.getDate() - (prevSunday.getDay() + 7) % 7);
    const week = completedWeeks.filter(week => week.date === moment(prevSunday).format('YYYY/MM/DD'))[0];
    if (week) {
      setWeeklyHours(week.hour);
    } else 
    {
      setWeeklyHours(0);
    }
  }, [selectedDays, completedWeeks]);

  return (
    <WeekDatesHeaderWrapper>
      <Grid>
        <Grid.Col lg={8} md={7} xs={12} style={{ paddingBottom: 0 }}>
          <div>Hours Entered: week <b>{weeklyHours} of 40</b> / month of {startMonth}. <b>{monthCompletedHours} of {monthWorkingHours}</b> </div>
        </Grid.Col>
        <Grid.Col lg={4} md={5} sm={8} xs={12} style={{ paddingBottom: 0 }}>
          <WeekDatesHeaderRow justify='flex-end' sm={{ justify: 'space-around' }} applyDeletableRowStyles={applyDeletableRowStyles}>
            <Grid.Col>
              <Grid grow>
                {
                  daysIndex.map((day) => (
                    <Grid.Col span={1} style={{ textAlign: 'center', padding: 0, fontSize: '14px' }} key={day}>
                      <p>
                        {day.substring(0, 2)}
                      </p>
                    </Grid.Col>
                  ))
                }
              </Grid>
            </Grid.Col>
          </WeekDatesHeaderRow>
          <WeekDatesRow justify='flex-end' applyDeletableRowStyles={applyDeletableRowStyles}>
            <Grid.Col>
              <Grid grow style={{ paddingBottom: 0 }}>
                {
                  selectedDays.map((day) => {
                    const strDay = day.getDate().toString();
                    return (
                      <Grid.Col span={1} style={{ textAlign: 'center', padding: 0, fontSize: '14px' }} key={strDay}>
                        <p data-test={`date-${strDay}`}>
                          {strDay}
                        </p>
                      </Grid.Col>
                    )
                  })
                }
              </Grid>
            </Grid.Col>
          </WeekDatesRow>
        </Grid.Col>
      </Grid>
    </WeekDatesHeaderWrapper>
  );
};

SelectedDaysHeader.propTypes = {
  selectedDays: PropTypes.arrayOf(Date),
};

const mapStateToProps = (state) => ({
  selectedDays: state.projectEntry.projectEntries.selectedDays,
  currentSystem: projectEntrySelectors.selectCurrentSystem(state),
  monthCompletedHours: state.projectEntry.monthCompletedHours,
  monthWorkingHours: state.projectEntry.monthWorkingHours,
  completedWeeks: state.projectEntry.completedWeeks
});
const mapDispatchToProps = (dispatch) => ({ });

export default connect(mapStateToProps, mapDispatchToProps)(SelectedDaysHeader);
